import { mutator } from 'satcheljs';

import resetApplicationSettingOverridesAction from '../actions/resetApplicationSettingOverridesAction';
import getStore from '../store/store';
import { defaultApplicationSettings } from '../store/applicationSettingsDefinitions';

import createApplicationSettingsDefaultOverrides from '../utils/createApplicationSettingsDefaultOverrides';

const resetApplicationSettingOverridesMutator = mutator(
    resetApplicationSettingOverridesAction,
    () => {
        const store = getStore();

        store.overrides = createApplicationSettingsDefaultOverrides(
            defaultApplicationSettings,
            false
        );
    }
);

export default resetApplicationSettingOverridesMutator;
